export const errorMessagesData =[
    {
      "name": "DEFAULT_ERROR",
      "text": "We're experiencing a technical issue while collecting your bid deposit. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "USER_DETAILS_ERROR",
      "text": "Technical error. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "PAYMENT_INIT_ERROR",
      "text": "Technical error. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "PAYMENT_GATEWAY_ERROR",
      "text": "Technical error. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "Bid_AMT_ERROR",
      "text": "Technical error. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "payment_intent_unexpected_state",
      "text": "Technical error. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "account_already_exists",
      "text": "The email address provided for the creation of a deferred account already has an account associated with it. Use the OAuth flow to connect the existing account to your platform."
    },
    {
      "name": "account_country_invalid_address",
      "text": "The country of the business address provided does not match the country of the account. Businesses must be located in the same country as the account."
    },
    {
      "name": "account_invalid",
      "text": "The account ID provided as a value for the Stripe-Account header is invalid. Check that your requests are specifying a valid account ID."
    },
    {
      "name": "account_number_invalid",
      "text": "The bank account number provided is invalid (e.g., missing digits). Bank account information varies from country to country. We recommend creating validations in your entry forms based on the bank account formats we provide."
    },
    {
      "name": "alipay_upgrade_required",
      "text": "This method for creating Alipay payments is not supported anymore. Please upgrade your integration to use Sources instead."
    },
    {
      "name": "amount_too_large",
      "text": "The specified amount is greater than the maximum amount allowed. Use a lower amount and try again."
    },
    {
      "name": "amount_too_small",
      "text": "The specified amount is less than the minimum amount allowed. Use a higher amount and try again."
    },
    {
      "name": "api_key_expired",
      "text": "We're experiencing a technical issue while collecting your bid deposit. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "authentication_required",
      "text": "The payment requires authentication to proceed. If your customer is off session, notify your customer to return to your application and complete the payment. If you provided the error_on_requires_action parameter, then your customer should try another card that does not require authentication."
    },
    {
      "name": "balance_insufficient",
      "text": "The transfer or payout could not be completed because the associated account does not have a sufficient balance available. Create a new transfer or payout using an amount less than or equal to the account's available balance."
    },
    {
      "name": "bank_account_declined",
      "text": "The bank account provided can not be used to charge, either because it is not verified yet or it is not supported."
    },
    {
      "name": "bank_account_exists",
      "text": "The bank account provided already exists on the specified Customer object. If the bank account should also be attached to a different customer, include the correct customer ID when making the request again."
    },
    {
      "name": "bank_account_unusable",
      "text": "The bank account provided cannot be used for payouts. A different bank account must be used."
    },
    {
      "name": "bank_account_unverified",
      "text": "Your Connect platform is attempting to share an unverified bank account with a connected account."
    },
    {
      "name": "bank_account_verification_failed",
      "text": "The bank account cannot be verified, either because the microdeposit amounts provided do not match the actual amounts, or because verification has failed too many times."
    },
    {
      "name": "bitcoin_upgrade_required",
      "text": "This method for creating Bitcoin payments is not supported anymore. Please upgrade your integration to use Sources instead."
    },
    {
      "name": "card_decline_rate_limit_exceeded",
      "text": "This card has been declined too many times. You can try to charge this card again after 24 hours. We suggest reaching out to your customer to make sure they have entered all of their information correctly and that there are no issues with their card."
    },
    {
      "name": "card_declined",
      "text": "The card has been declined. Please check the card details or use a different card."
    },
    {
      "name": "charge_already_captured",
      "text": "The charge you're attempting to capture has already been captured."
    },
    {
      "name": "charge_already_refunded",
      "text": "The charge you're attempting to refund has already been refunded."
    },
    {
      "name": "charge_disputed",
      "text": "The charge you're attempting to refund has been charged back. Check the disputes documentation to learn how to respond to the dispute."
    },
    {
      "name": "charge_exceeds_source_limit",
      "text": "This charge would cause you to exceed your rolling-window processing limit for this source type. Please retry the charge later, or contact us to request a higher processing limit."
    },
    {
      "name": "charge_expired_for_capture",
      "text": "The charge cannot be captured as the authorization has expired. Auth and capture charges must be captured within seven days."
    },
    {
      "name": "charge_invalid_parameter",
      "text": "We're experiencing a technical issue while collecting your bid deposit. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "country_unsupported",
      "text": "Your platform attempted to create a custom account in a country that is not yet supported. Make sure that users can only sign up in countries supported by custom accounts."
    },
    {
      "name": "coupon_expired",
      "text": "The coupon provided for a subscription or order has expired. Either create a new coupon, or use an existing one that is valid."
    },
    {
      "name": "customer_max_subscriptions",
      "text": "The maximum number of subscriptions for a customer has been reached. Contact us if you are receiving this error."
    },
    {
      "name": "email_invalid",
      "text": "The email address is invalid (e.g., not properly formatted). Check that the email address is properly formatted and only includes allowed characters."
    },
    {
      "name": "expired_card",
      "text": "The card has expired. Check the expiration date or use a different card."
    },
    {
      "name": "incorrect_address",
      "text": "The card's address is incorrect. Check the card's address or use a different card."
    },
    {
      "name": "incorrect_cvc",
      "text": "The card's security code is incorrect. Check the card's security code or use a different card."
    },
    {
      "name": "incorrect_number",
      "text": "The card number is incorrect. Check the card's number or use a different card."
    },
    {
      "name": "incorrect_zip",
      "text": "The card's postal code is incorrect. Check the card's postal code or use a different card."
    },
    {
      "name": "instant_payouts_unsupported",
      "text": "This card is not eligible for Instant Payouts. Try a debit card from a supported bank."
    },
    {
      "name": "invalid_card_type",
      "text": "The card provided as an external account is not supported for payouts. Provide a non-prepaid debit card instead."
    },
    {
      "name": "invalid_charge_amount",
      "text": "The specified amount is invalid. The charge amount must be a positive integer in the smallest currency unit, and not exceed the minimum or maximum amount."
    },
    {
      "name": "invalid_cvc",
      "text": "The card's security code is invalid. Check the card's security code or use a different card."
    },
    {
      "name": "invalid_expiry_month",
      "text": "The card's expiration month is incorrect. Check the expiration date or use a different card."
    },
    {
      "name": "invalid_expiry_year",
      "text": "The card's expiration year is incorrect. Check the expiration date or use a different card."
    },
    {
      "name": "invalid_number",
      "text": "The card number is invalid. Check the card details or use a different card."
    },
    {
      "name": "invalid_source_usage",
      "text": "The source cannot be used because it is not in the correct state (e.g., a charge request is trying to use a source with a pending, failed, or consumed source). Check the status of the source you are attempting to use."
    },
    {
      "name": "invoice_no_customer_line_items",
      "text": "An invoice cannot be generated for the specified customer as there are no pending invoice items. Check that the correct customer is being specified or create any necessary invoice items first."
    },
    {
      "name": "invoice_no_subscription_line_items",
      "text": "An invoice cannot be generated for the specified subscription as there are no pending invoice items. Check that the correct subscription is being specified or create any necessary invoice items first."
    },
    {
      "name": "invoice_not_editable",
      "text": "The specified invoice can no longer be edited. Instead, consider creating additional invoice items that will be applied to the next invoice. You can either manually generate the next invoice or wait for it to be automatically generated at the end of the billing cycle."
    },
    {
      "name": "invoice_payment_intent_requires_action",
      "text": "This payment requires additional user action before it can be completed successfully. Payment can be completed using the PaymentIntent associated with the invoice. See this page for more details."
    },
    {
      "name": "invoice_upcoming_none",
      "text": "There is no upcoming invoice on the specified customer to preview. Only customers with active subscriptions or pending invoice items have invoices that can be previewed."
    },
    {
      "name": "livemode_mismatch",
      "text": "Test and live mode API keys, requests, and objects are only available within the mode they are in"
    },
    {
      "name": "lock_timeout",
      "text": "This object cannot be accessed right now because another API request or Stripe process is currently accessing it. If you see this error intermittently, retry the request. If you see this error frequently and are making multiple concurrent requests to a single object, make your requests serially or at a lower rate."
    },
    {
      "name": "missing",
      "text": "Both a customer and source ID have been provided, but the source has not been saved to the customer. To create a charge for a customer with a specified source, you must first\u00a0save the card details."
    },
    {
      "name": "not_allowed_on_standard_account",
      "text": "Transfers and payouts on behalf of a Standard connected account are not allowed."
    },
    {
      "name": "order_creation_failed",
      "text": "The order could not be created. Check the order details and then try again."
    },
    {
      "name": "order_required_settings",
      "text": "The order could not be processed as it is missing required information. Check the information provided and try again."
    },
    {
      "name": "order_status_invalid",
      "text": "The order cannot be\u00a0updated\u00a0because the status provided is either invalid or does not follow the\u00a0order lifecycle\u00a0(e.g., an order cannot transition from\u00a0created\u00a0to\u00a0fulfilled\u00a0without first transitioning to\u00a0paid)."
    },
    {
      "name": "order_upstream_timeout",
      "text": "The request timed out. Try again later."
    },
    {
      "name": "out_of_inventory",
      "text": "The SKU is out of stock. If more stock is available, update the SKU\u2019s inventory quantity and try again."
    },
    {
      "name": "parameter_invalid_empty",
      "text": "One or more required values were not provided. Make sure requests include all required parameters."
    },
    {
      "name": "parameter_invalid_integer",
      "text": "One or more of the parameters requires an integer, but the values provided were a different type. Make sure that only supported values are provided for each attribute. Refer to our\u00a0API documentation\u00a0to look up the type of data each attribute supports."
    },
    {
      "name": "parameter_invalid_string_blank",
      "text": "One or more values provided only included whitespace. Check the values in your request and update any that contain only whitespace."
    },
    {
      "name": "parameter_invalid_string_empty",
      "text": "One or more required string values is empty. Make sure that string values contain at least one character."
    },
    {
      "name": "parameter_missing",
      "text": "One or more required values are missing. Check our\u00a0API documentation\u00a0to see which values are required to create or modify the specified resource."
    },
    {
      "name": "parameter_unknown",
      "text": "The request contains one or more unexpected parameters. Remove these and try again."
    },
    {
      "name": "parameters_exclusive",
      "text": "Two or more mutually exclusive parameters were provided. Check our\u00a0API documentation\u00a0or the returned error message to see which values are permitted when creating or modifying the specified resource."
    },
    {
      "name": "payment_intent_action_required",
      "text": "The provided payment method requires customer actions to complete, but\u00a0error_on_requires_action\u00a0was set. If you\u2019d like to add this payment method to your integration, we recommend that you first\u00a0upgrade your integration to handle actions."
    },
    {
      "name": "payment_intent_authentication_failure",
      "text": "The provided payment method has failed authentication. Provide a new payment method to attempt to fulfill this PaymentIntent again."
    },
    {
      "name": "payment_intent_incompatible_payment_method",
      "text": "The PaymentIntent expected a payment method with different properties than what was provided."
    },
    {
      "name": "payment_intent_invalid_parameter",
      "text": "One or more provided parameters was not allowed for the given operation on the PaymentIntent. Check our\u00a0API reference\u00a0or the returned error message to see which values were not correct for that PaymentIntent."
    },
    {
      "name": "payment_intent_payment_attempt_failed",
      "text": "The latest payment attempt for the PaymentIntent has failed. Check the\u00a0last_payment_error\u00a0property on the PaymentIntent for more details, and provide a new payment method to attempt to fulfill this PaymentIntent again."
    },
    {
      "name": "payment_intent_unexpected_state0",
      "text": "The PaymentIntent's state was incompatible with the operation you were trying to perform."
    },
    {
      "name": "payment_method_unactivated",
      "text": "The charge cannot be created as the payment method used has not been activated. Activate the payment method in the\u00a0Dashboard, then try again."
    },
    {
      "name": "payment_method_unexpected_state",
      "text": "The provided payment method\u2019s state was incompatible with the operation you were trying to perform. Confirm that the payment method is in an allowed state for the given operation before attempting to perform it."
    },
    {
      "name": "payouts_not_allowed",
      "text": "Payouts have been disabled on the connected account. Check the connected account\u2019s status to see if any\u00a0additional information\u00a0needs to be provided, or if payouts have been disabled for\u00a0another reason."
    },
    {
      "name": "platform_api_key_expired",
      "text": "The API key provided by your Connect platform has expired. This occurs if your platform has either generated a new key or the connected account has been disconnected from the platform. Obtain your current API keys from the\u00a0Dashboard\u00a0and update your integration, or reach out to the user and reconnect the account."
    },
    {
      "name": "postal_code_invalid",
      "text": "The postal code provided was incorrect."
    },
    {
      "name": "processing_error",
      "text": "An error occurred while processing the card. Try again later or with a different payment method."
    },
    {
      "name": "product_inactive",
      "text": "The product this SKU belongs to is no longer available for purchase."
    },
    {
      "name": "rate_limit",
      "text": "Too many requests hit the API too quickly. We recommend an exponential backoff of your requests."
    },
    {
      "name": "resource_already_exists",
      "text": "A resource with a user-specified ID (e.g., plan or coupon) already exists. Use a different, unique value for\u00a0id\u00a0and try again."
    },
    {
      "name": "resource_missing",
      "text": "The ID provided is not valid. Either the resource does not exist, or an ID for a different resource has been provided."
    },
    {
      "name": "routing_number_invalid",
      "text": "The bank routing number provided is invalid."
    },
    {
      "name": "secret_key_required",
      "text": "The API key provided is a publishable key, but a secret key is required. Obtain your current API keys from the\u00a0Dashboard\u00a0and update your integration to use them."
    },
    {
      "name": "sepa_unsupported_account",
      "text": "Your account does not support\u00a0SEPA\u00a0payments."
    },
    {
      "name": "setup_attempt_failed",
      "text": "The latest setup attempt for the SetupIntent has failed. Check the\u00a0last_setup_error\u00a0property on the SetupIntent for more details, and provide a new payment method to attempt to set it up again."
    },
    {
      "name": "setup_intent_authentication_failure",
      "text": "The provided payment method has failed authentication. Provide a new payment method to attempt to fulfill this SetupIntent again."
    },
    {
      "name": "setup_intent_invalid_parameter",
      "text": "One or more provided parameters was not allowed for the given operation on the SetupIntent. Check our\u00a0API reference\u00a0or the returned error message to see which values were not correct for that SetupIntent."
    },
    {
      "name": "setup_intent_unexpected_state",
      "text": "The SetupIntent\u2019s state was incompatible with the operation you were trying to perform."
    },
    {
      "name": "shipping_calculation_failed",
      "text": "Shipping calculation failed as the information provided was either incorrect or could not be verified."
    },
    {
      "name": "sku_inactive",
      "text": "The SKU is inactive and no longer available for purchase. Use a different SKU, or make the current SKU active again."
    },
    {
      "name": "state_unsupported",
      "text": "Occurs when providing the\u00a0legal_entity\u00a0information for a U.S. custom account, if the provided state is not supported. (This is mostly associated states and territories.)"
    },
    {
      "name": "routing_number_invalid",
      "text": "The bank routing number provided is invalid."
    },
    {
      "name": "secret_key_required",
      "text": "The API key provided is a publishable key, but a secret key is required. Obtain your current API keys from the\u00a0Dashboard\u00a0and update your integration to use them."
    },
    {
      "name": "sepa_unsupported_account",
      "text": "Your account does not support\u00a0SEPA\u00a0payments."
    },
    {
      "name": "setup_attempt_failed",
      "text": "The latest setup attempt for the SetupIntent has failed. Check the\u00a0last_setup_error\u00a0property on the SetupIntent for more details, and provide a new payment method to attempt to set it up again."
    },
    {
      "name": "setup_intent_authentication_failure",
      "text": "The provided payment method has failed authentication. Provide a new payment method to attempt to fulfill this SetupIntent again."
    },
    {
      "name": "setup_intent_invalid_parameter",
      "text": "One or more provided parameters was not allowed for the given operation on the SetupIntent. Check our\u00a0API reference\u00a0or the returned error message to see which values were not correct for that SetupIntent."
    },
    {
      "name": "setup_intent_unexpected_state",
      "text": "The SetupIntent\u2019s state was incompatible with the operation you were trying to perform."
    },
    {
      "name": "shipping_calculation_failed",
      "text": "Shipping calculation failed as the information provided was either incorrect or could not be verified."
    },
    {
      "name": "sku_inactive",
      "text": "The SKU is inactive and no longer available for purchase. Use a different SKU, or make the current SKU active again."
    },
    {
      "name": "state_unsupported",
      "text": "Occurs when providing the\u00a0legal_entity\u00a0information for a U.S. custom account, if the provided state is not supported. (This is mostly associated states and territories.)"
    },
    {
      "name": "tax_id_invalid",
      "text": "The tax ID number provided is invalid (e.g., missing digits). Tax ID information varies from country to country, but must be at least nine digits."
    },
    {
      "name": "taxes_calculation_failed",
      "text": "Tax calculation for the order failed."
    },
    {
      "name": "testmode_charges_only",
      "text": "Your account has not been activated and can only make test charges.\u00a0Activate your account\u00a0in the Dashboard to begin processing live charges."
    },
    {
      "name": "tls_version_unsupported",
      "text": "Your integration is using an older version of\u00a0TLS\u00a0that is unsupported. You must be using TLS 1.2 or above."
    },
    {
      "name": "token_already_used",
      "text": "The token provided has already been used. You must create a new token before you can retry this request."
    },
    {
      "name": "token_in_use",
      "text": "The token provided is currently being used in another request. This occurs if your integration is making duplicate requests simultaneously."
    },
    {
      "name": "transfers_not_allowed",
      "text": "The requested transfer cannot be created.\u00a0Contact us\u00a0if you are receiving this error."
    },
    {
      "name": "upstream_order_creation_failed",
      "text": "The order could not be created. Check the order details and then try again."
    },
    {
      "name": "url_invalid",
      "text": "The URL provided is invalid."
    },
    {
      "name": "API_KEY_NOT_AVAILABLE",
      "text": "Technical error. Please wait for a few minutes and try again.  If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "PAYMENT_GATEWAY_NOTLOADED",
      "text": "Technical error. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "TECHNICAL_ERROR",
      "text": "Technical error. Please wait for a few minutes and try again.  If the issue still persists, please reach out to our customer support team at (855) 882-1314."
    },
    {
      "name": "CC_FINGER_PRINT_FRAUD_USER",
      "text": "You have been blocked from placing bids due to your past activity. Please contact customer support if you feel this has been done in error."
    },
    {
      "name": "BROWSER_FINGER_PRINT_FRAUD_USER",
      "text": "We are unable to complete your bid at this time. Due to your prior activity on Hubzu, your account has been blocked from placing bids or offers. Please contact Customer Care if you feel we've made an error."
    }
  
  ];